import { FC } from "react";
import { Navigate, useNavigate } from "react-router-dom";

import { CreateUser } from "@/modules";
import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import { pages } from "@/root/consts";
import { AuthApi } from "@/api";
import { setAreUsers, setUserType } from "@/store/reducers/user/userSlice";
import { AxiosError } from "axios";

const CreateUserPage: FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const canCreate = useAppSelector((state) => !state.userReducer.areUsers);

  if (!canCreate) {
    return <Navigate to="/" replace />;
  }

  const redirect = async () => {
    try {
      const { userType } = await AuthApi.me();
      dispatch(setUserType(userType));
    } catch (e) {
      if (e instanceof AxiosError && e.response?.status === 404) {
        dispatch(setAreUsers(false));
        return navigate(pages.createUser.path);
      }
      navigate(pages.login.path);
    }
  };

  return (
    <div data-testid="createUserPage-page">
      <CreateUser onCreated={redirect} />
    </div>
  );
};

export default CreateUserPage;
